var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-hospital-manage',{ref:"table",staticClass:"pt-hospital-manage__withData",attrs:{"companyList":_vm.companyList},on:{"deleteHospital":_vm.deleteHospital}})}
var staticRenderFns = []

export { render, staticRenderFns }